import {
  BadgePercent,
  ChartNoAxesCombined,
  Boxes,
  ChevronDown,
  ClipboardList,
  LayoutDashboard,
  LogOut,
  Menu,
  PackageSearch,
  Settings,
  Sparkles,
  UsersRound,
  X,
} from "lucide-react";
import { useState, type ReactNode } from "react";
import { useAdminAuth } from "../auth/AdminAuth";
import type { PageKey } from "../types";
import { classNames } from "../utils";

const items: Array<{ id: PageKey; label: string; icon: typeof LayoutDashboard }> = [
  { id: "dashboard", label: "Начало", icon: LayoutDashboard },
  { id: "analytics", label: "Анализи", icon: ChartNoAxesCombined },
  { id: "orders", label: "Поръчки", icon: ClipboardList },
  { id: "products", label: "Продукти", icon: PackageSearch },
  { id: "customers", label: "Клиенти", icon: UsersRound },
  { id: "catalogue", label: "Каталог", icon: Boxes },
  { id: "marketing", label: "Промоции и банер", icon: BadgePercent },
  { id: "admins", label: "Достъп", icon: Settings },
];

export function Layout({ page, onPage, children }: { page: PageKey; onPage: (page: PageKey) => void; children: ReactNode }) {
  const { user, role, signOut } = useAdminAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const visibleItems = role === "support"
    ? items.filter((item) => ["dashboard", "orders", "customers"].includes(item.id))
    : role === "owner" ? items : items.filter((item) => !["admins", "analytics"].includes(item.id));

  const navigate = (nextPage: PageKey) => {
    onPage(nextPage);
    setMenuOpen(false);
  };

  return <div className="app-shell">
    <aside className={classNames("sidebar", menuOpen && "open")}>
      <div className="sidebar-brand"><div className="brand-mark small"><Sparkles size={18} /></div><div><strong>Muse Shop</strong><span>Администрация</span></div><button className="mobile-close" aria-label="Затвори менюто" onClick={() => setMenuOpen(false)}><X /></button></div>
      <nav>{visibleItems.map(({ id, label, icon: Icon }) => <button key={id} className={classNames(page === id && "active")} onClick={() => navigate(id)}><Icon size={19} /><span>{label}</span></button>)}</nav>
      <div className="sidebar-help"><Sparkles size={18} /><strong>Всичко е под контрол</strong><span>Промените се синхронизират автоматично с приложението.</span></div>
    </aside>
    {menuOpen && <div className="sidebar-shade" onClick={() => setMenuOpen(false)} />}
    <div className="main-column">
      <header className="topbar">
        <button className="mobile-menu" aria-label="Отвори менюто" onClick={() => setMenuOpen(true)}><Menu /></button>
        <div className="topbar-context"><span>Магазин</span><strong>{visibleItems.find((item) => item.id === page)?.label ?? "Начало"}</strong></div>
        <div className="profile-menu">
          <button className="profile-button" onClick={() => setProfileOpen(!profileOpen)}><span className="avatar">{(user.email?.[0] ?? "M").toUpperCase()}</span><span className="profile-copy"><strong>{user.displayName || "Администратор"}</strong><small>{user.email}</small></span><ChevronDown size={16} /></button>
          {profileOpen && <div className="profile-popover"><div><strong>{user.email}</strong><span>Роля: {role}</span></div><button onClick={signOut}><LogOut size={17} /> Изход</button></div>}
        </div>
      </header>
      <main className="page-content">{children}</main>
    </div>
  </div>;
}
